import usePopupScrollLock from "./usePopupScrollLock";
import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import UnavailableFeatureDialog from "./UnavailableFeatureDialog";

const PRIZES = [
  "৳ 8",
  "৳ 18",
  "৳ 68",
  "৳ 58",
  "৳ 88",
  "৳ 888",
  "৳ 588",
  "৳ 8,888",
];

const WINNERS = [
  { user: "su******9", amount: "৳ 5.88" },
  { user: "t8********8", amount: "৳ 5.88" },
  { user: "01*******5", amount: "৳ 5.88" },
];

function useCountdown(ms) {
  const [left, setLeft] = useState(ms);
  useEffect(() => {
    const end = Date.now() + ms;
    const id = window.setInterval(() => setLeft(Math.max(0, end - Date.now())), 1000);
    return () => window.clearInterval(id);
  }, [ms]);
  const total = Math.floor(left / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    mins: Math.floor((total % 3600) / 60),
    secs: total % 60,
  };
}

const pad = (n) => String(n).padStart(2, "0");

export default function ReferenceRewardPopup({ onClose, initialTab = 0, initialTask = false }) {
  const navigate = useNavigate();
  usePopupScrollLock();
  const contentRef = useRef(null);
  const [selectedEgg, setSelectedEgg] = useState(null);
  const [wheelTask, setWheelTask] = useState(initialTask);
  const openDeposit = () => {
    onClose("deposit");
    navigate(isMobile ? "/member/deposit" : "/member?tab=deposit");
  };
  const openBetting = () => {
    onClose("betting");
    navigate("/rng");
  };
  const [activeTab, setActiveTab] = useState(initialTab);
  const [unavailable, setUnavailable] = useState(false);
  const time = useCountdown(29 * 86400000 + 13 * 3600000 + 38 * 60000 + 5 * 1000);
  const [dailyEnd] = useState(() => {
    // Midnight in Bangladesh; reopening the dialog must not restart the timer.
    const now = Date.now();
    const offset = 6 * 3600000;
    return Math.floor((now + offset) / 86400000) * 86400000 + 86400000 - offset;
  });
  const [dailyDuration] = useState(() => Math.max(0, dailyEnd - Date.now()));
  const dailyTime = useCountdown(dailyDuration);
  const displayTime = activeTab === 0 ? dailyTime : time;
  const winners = useMemo(() => [...WINNERS, ...WINNERS], []);

  useEffect(() => {
    const close = (event) => {
      if (event.key === "Escape" && !unavailable) {
        if (wheelTask || selectedEgg !== null) {
          if (initialTask) onClose();
          else { setWheelTask(false); setSelectedEgg(null); }
        } else onClose(undefined, activeTab);
      }
    };
    document.addEventListener("keydown", close);
    return () => {
      document.removeEventListener("keydown", close);
    };
  }, [onClose, unavailable, wheelTask, selectedEgg, initialTask, activeTab]);

  useEffect(() => {
    if (contentRef.current) contentRef.current.scrollTop = 0;
  }, [selectedEgg, wheelTask, activeTab]);

  return createPortal(
    <div
      className={`reference-rewards-overlay${wheelTask ? " reference-rewards-task-overlay" : ""}`}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !unavailable) onClose(undefined, activeTab);
      }}
    >
      <section className={`reference-rewards-popup reference-rewards-wheel-popup reference-rewards-egg-popup${activeTab === 1 ? " reference-rewards-spinner-popup" : ""}${selectedEgg !== null || wheelTask ? " reference-rewards-task-popup" : ""}${wheelTask ? " reference-rewards-wheel-task-popup" : ""}`} role="dialog" aria-modal="true" aria-label="Rewards">

        <button className="reference-rewards-close" type="button" aria-label="Close rewards" onClick={() => onClose(undefined, activeTab)}>
          ×
        </button>
        {(selectedEgg !== null || wheelTask) && (
          <button className="reference-rewards-back" type="button" aria-label={initialTask ? "Back to treasure" : wheelTask ? "Back to prize wheel" : "Back to golden eggs"} onClick={() => { if (initialTask) onClose(); else { setSelectedEgg(null); setWheelTask(false); } }}>‹</button>
        )}
        <img className="reference-rewards-crown" src="/assets/NewImages/crown-gold.webp" alt="" aria-hidden="true" />
        <header>
          <span className="reference-rewards-ribbon">Rewards</span>
        </header>
        <div className="reference-rewards-content" ref={contentRef}>
          {wheelTask ? (
            <div className="reference-rewards-tasks reference-rewards-wheel-tasks">
              <p className="reference-rewards-task-heading">Complete the task to claim your voucher</p>
              <div className="reference-rewards-progress" role="progressbar" aria-label="Voucher task progress" aria-valuenow={0} aria-valuemin={0} aria-valuemax={100}><em>0.00%</em></div>
              <div className="reference-rewards-task-panel">
                <article className="reference-rewards-task">
                  <div className="reference-rewards-task-row">
                    <p>Amount to deposit -<br />After claiming the voucher ≥<br /><strong>৳ 200.00</strong></p>
                    <button type="button" onClick={openDeposit}>Deposit</button>
                  </div>
                  <div className="reference-rewards-task-meter" role="progressbar" aria-label="Amount to deposit" aria-valuenow={0} aria-valuemin={0} aria-valuemax={200}><span>0</span></div>
                  <div className="reference-rewards-task-range"><span>0</span><span>200</span></div>
                </article>
                <article className="reference-rewards-task">
                  <div className="reference-rewards-task-row">
                    <p>All vendor - Slot or Fish -<br />Valid bet - After claiming the<br />voucher ≥ <strong>৳ 2,000.00</strong></p>
                    <button type="button" onClick={openBetting}>Betting</button>
                  </div>
                  <div className="reference-rewards-task-meter" role="progressbar" aria-label="Valid bet" aria-valuenow={0} aria-valuemin={0} aria-valuemax={2000}><span>0</span></div>
                  <div className="reference-rewards-task-range"><span>0</span><span>2000</span></div>
                </article>

              </div>
            </div>
          ) : selectedEgg !== null ? (
            <div className="reference-rewards-tasks">
              <p className="reference-rewards-task-heading">Complete the task to claim your voucher</p>
              <div className="reference-rewards-progress" role="progressbar" aria-label="Voucher task progress" aria-valuenow={0} aria-valuemin={0} aria-valuemax={100}><em>0.00%</em></div>
              <div className="reference-rewards-task-panel">
                {[{ title: "Amount to deposit", target: 100, amount: true }, { title: "Deposit count", target: 3 }].map(task => (
                  <article className="reference-rewards-task" key={task.title}>
                    <div className="reference-rewards-task-row">
                      <p>{task.title} -<br />After claiming the voucher {task.amount ? "≥" : "-"} <strong>{task.amount ? <><br />৳ 100.00</> : "3"}</strong></p>
                      <button type="button" onClick={openDeposit}>Deposit</button>
                    </div>
                    <div className="reference-rewards-task-meter" role="progressbar" aria-label={task.title} aria-valuenow={0} aria-valuemin={0} aria-valuemax={task.target}><span>0</span></div>
                    <div className="reference-rewards-task-range"><span>0</span><span>{task.target}</span></div>
                  </article>
                ))}
              </div>
            </div>
          ) : <>
          <nav aria-label="Reward types">
            {activeTab === 1 && <button type="button" className="reference-rewards-tab-arrow previous" aria-label="Previous reward: golden eggs" onClick={() => setActiveTab(0)}><span aria-hidden="true">◀</span></button>}
            <button type="button" className={activeTab === 0 ? "active" : ""} aria-pressed={activeTab === 0} onClick={() => setActiveTab(0)}>প্রতিদিন লগইন করে সোনার ডিম ভাঙুন।</button>
            <button type="button" className={activeTab === 1 ? "active" : ""} aria-pressed={activeTab === 1} onClick={() => setActiveTab(1)}>অ্যাপটি ডাউনলোড করুন এবং পুরস্কার নিন।</button>
            {activeTab === 0 && <button type="button" className="reference-rewards-tab-arrow" aria-label="Next reward: prize wheel" onClick={() => setActiveTab(1)}><span aria-hidden="true">▶</span></button>}
          </nav>
          <h2>{activeTab === 0 ? "প্রতিদিন লগইন করে সোনার ডিম ভাঙুন।" : "অ্যাপটি ডাউনলোড করুন এবং পুরস্কার নিন।"}</h2>

          {<div className="reference-rewards-time">
            <span className="reference-rewards-time-label">
              <i aria-hidden="true" /> Remaining time
            </span>
            {[
              ...(activeTab === 1 ? [[displayTime.days, "Days"]] : []),
              [displayTime.hours, "Hours"],
              [displayTime.mins, "Min"],
              [displayTime.secs, "Sec"],
            ].map(([value, label], index) => (
              <div key={label} className="reference-rewards-time-unit">
                {index > 0 ? <b>:</b> : null}
                <span>
                  {pad(value)}
                  <small>{label}</small>
                </span>
              </div>
            ))}
          </div>}

          {activeTab === 0 ? (
            <div className="reference-rewards-egg-card">
              <div className="reference-rewards-eggs">
                {Array.from({ length: 8 }, (_, index) => (
                  <button key={index} type="button" aria-label={`Open golden egg ${index + 1}`} onClick={() => setSelectedEgg(index)}>
                    <img src="/assets/bdtwin/egg.df99caec.png" alt="" />
                  </button>
                ))}
              </div>
              <div className="reference-rewards-claim-row">
                <button className="reference-rewards-claim" type="button" onClick={() => setUnavailable(true)}>Claim</button>
                <span className="reference-rewards-claim-soon">Claiming soon</span>
              </div>
            </div>
          ) : <div className="reference-rewards-spinner-card">
          <div className="reference-rewards-wheel-stage">
            <div className="reference-rewards-wheel-glow" aria-hidden="true" />
            <div className="reference-rewards-wheel-lights" aria-hidden="true" />
            <div className="reference-rewards-wheel-frame">
              <div className="reference-rewards-wheel-disk">
                <ul>
                  {PRIZES.map((prize, index) => (
                    <li key={`${prize}-${index}`} className={`item-${index}`}>
                      <span className="reference-rewards-wheel-prize">
                        <img src="/assets/bdtwin/wheel/money.png" alt="" />
                        <span>{prize}</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
              <button type="button" className="reference-rewards-go" onClick={() => setWheelTask(true)} aria-label="Spin rewards">GO</button>
            </div>
          </div>

          <div className="reference-rewards-claim-row">
            <button className="reference-rewards-claim" type="button" onClick={() => setUnavailable(true)}>
              Claim
            </button>
            <span className="reference-rewards-claim-soon">Claiming soon</span>
          </div>

          </div>}

          <div className="reference-rewards-progress" role="progressbar" aria-label="Reward progress" aria-valuenow={0} aria-valuemin={0} aria-valuemax={100}>
            <i style={{ width: "0%" }} />
            <em>0.00%</em>
          </div>

          <div className="reference-rewards-winners">
            <span className="reference-rewards-trophy" aria-hidden="true">
              🏆
            </span>
            <div className="reference-rewards-winner-track">
              <div className="reference-rewards-winner-list">
                {winners.map((row, index) => (
                  <div key={`${row.user}-${index}`}>
                    <span>{row.user}</span>
                    <strong>{row.amount}</strong>
                  </div>
                ))}
              </div>
            </div>
          </div>
          </>}
        </div>
      </section>
      {unavailable && <UnavailableFeatureDialog feature="Rewards" onClose={() => setUnavailable(false)} />}
    </div>,
    document.body,
  );
}
